import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authTokenInterceptor } from './compartidos/interceptors/auth-token.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
// Firebase imports
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { environment } from '../environments/environment';
/*
 * Realtime Database y Functions se proveen SÓLO para el alta de usuarios.
 *
 * MUEBA dejó de LEER el nodo users/{uid} para armar el perfil, que era una
 * segunda fuente de verdad (ver auth-init.service.ts). Pero al dar de alta sí
 * hay que ESCRIBIRLO: ese nodo lo consume el repositorio de archivos, y un
 * usuario creado sin él quedaría fuera de ese sistema.
 *
 * Functions es para la callable createUser, que es quien crea la cuenta en
 * Authentication.
 */
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideFunctions, getFunctions } from '@angular/fire/functions';

// Pipe para las Fechas
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
registerLocaleData(localeEsMx, 'es-MX');

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withComponentInputBinding()), // Habilita la vinculación automática
    // El interceptor adjunta el ID token de Firebase a cada llamada a la API
    provideHttpClient(withFetch(), withInterceptors([authTokenInterceptor])),

    // Locale configurado
    { provide: LOCALE_ID, useValue: 'es-MX' },

    // Proveedores de Firebase
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideDatabase(() => getDatabase()),
    provideFunctions(() => getFunctions())
  ]
};
